import { StandardEvents } from '@shopify/events';

const headerResources = new WeakMap();
const initHeaders = () => {
  document.querySelectorAll('[data-cm-header]').forEach((header) => {
    if (header.dataset.cmReady) return;
    header.dataset.cmReady = 'true';
    const controller = new AbortController();
    const signal = controller.signal;
    const updateHeaderHeight = () => {
      const headerHeight = header.getBoundingClientRect().height;
      const group = document.getElementById('header-group');
      const groupHeight = group ? group.getBoundingClientRect().height : headerHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--header-group-height', `${Math.max(headerHeight, groupHeight)}px`);
    };
    const observer = new ResizeObserver(updateHeaderHeight);
    observer.observe(header);
    headerResources.set(header, { controller, observer });
    updateHeaderHeight();
    const trigger = header.querySelector('[data-cm-menu-open]');
    const dialog = header.querySelector('.cm-mobile-dialog');
    const close = header.querySelector('[data-cm-menu-close]');
    if (trigger && dialog && close) {
      trigger.addEventListener('click', () => {
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('cm-menu-open');
      }, { signal });
      close.addEventListener('click', () => dialog.close(), { signal });
      dialog.addEventListener('click', (event) => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      }, { signal });
      dialog.addEventListener('close', () => {
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('cm-menu-open');
        trigger.focus();
      }, { signal });
    }
    const details = header.querySelectorAll('.cm-desktop-nav details, .cm-locale-details');
    details.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (item.open) details.forEach((other) => { if (other !== item) other.open = false; });
      }, { signal });
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && item.open) {
          item.open = false;
          item.querySelector('summary')?.focus();
        }
      }, { signal });
    });
    document.addEventListener('click', (event) => {
      details.forEach((item) => { if (!item.contains(event.target)) item.open = false; });
    }, { signal });
  });
};
const updateCount = (count) => {
  if (!Number.isFinite(Number(count))) return;
  document.querySelectorAll('[data-cm-cart-count]').forEach((node) => {
    node.textContent = String(count);
    node.hidden = Number(count) === 0;
  });
};
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ cart, detail }) => {
    const count = cart?.totalQuantity ?? detail?.itemCount;
    if (count !== undefined) updateCount(count);
  }).catch(() => {});
});
document.addEventListener('cart:update', (event) => {
  const count = event.detail?.resource?.item_count ?? event.detail?.cart?.item_count ?? event.detail?.item_count;
  if (count !== undefined) updateCount(count);
});
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  const root = window.Shopify?.routes?.root || '/';
  fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.ok ? response.json() : null).then((cart) => { if (cart) updateCount(cart.item_count); }).catch(() => {});
});
document.addEventListener('shopify:section:load', initHeaders);
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-cm-header]').forEach((header) => {
    const resources = headerResources.get(header);
    resources?.controller.abort();
    resources?.observer.disconnect();
    headerResources.delete(header);
    delete header.dataset.cmReady;
  });
  document.body.classList.remove('cm-menu-open');
});
initHeaders();
